<div class="bg-white">
  <div class="text-primary-900 p-4 m-6 border-solid border border-x-0 border-blue-900 items-center text-center">
    <h3 class="items-center flex justify-center">
      <img class="h-20 w-20 text-left" src="../../assets/images/jax-logo.png">
      BioConnect Help
    </h3>
  </div>

  <div class="text-primary-900 text-center p-4 m-6 border-solid border border-x-0 border-blue-900">
    <h4>BioConnect Documentation
      <i class="pi pi-external-link" (click)="onNavigate(docLink)">
      </i>
    </h4>
    <p>For full documentation for JAX BioConnect go to <a href="https://docs.bioconnect.jax.org/" class="external-link"
        target="_blank">https://docs.bioconnect.jax.org/.</a> <br> There you will find use
      cases,
      developer documentation, and other handy resources in the BioConnect ecosystem. </p>
  </div>

  <div class="text-primary-900 text-center p-4 m-6 border-solid border border-x-0 border-blue-900">
    <h4>Data Use Guidelines</h4>
    <p>
      Re-use policies for data that are indexed in BioConnect is determined by the
      investigator of record. Contact information for the investigator is provided for each study.
      For assistance, contact <a href="mailto:bioconnect_support@jax.org" class="external-link">
        bioconnect_support&#64;jax.org</a>.
    </p>
  </div>

  <div class="text-primary-900 text-center p-4 m-6 border-solid border border-x-0 border-blue-900">
    <h4>Frequently Asked Questions (FAQs)</h4>
    <p-accordion>
      @for (faq of faqs; track faq.question; let i = $index) {
      <p-accordion-panel [value]="i.toString()" class="text-lg p-4" (click)="selectFAQ(faq.question)">
        <p-accordion-header>{{ faq.question }}</p-accordion-header>
        <p-accordion-content>
          <div class="flex justify-start text-left pl-5 font-sm">
            <markdown [data]="faq.answer" class="markdown"></markdown> 
          </div>
        </p-accordion-content>
      </p-accordion-panel>
      }
    </p-accordion>
  </div>

  <div class="text-primary-900 text-center p-4 m-6 border-solid border border-x-0 border-blue-900">
    <h4>About</h4>
    <p>The Jackson Laboratory BioConnect <br /> Beta v2.7.0</p>
  </div>

  <div class="text-primary-900 text-center p-4 m-6 border-solid border border-x-0 border-blue-900">
    <h4>Contact Us</h4>
    Email us at
    <a href="mailto:bioconnect_support@jax.org" class="external-link">bioconnect_support&#64;jax.org</a>
    <br> BioConnect Slack Channel: 
    
    <a href="https://join.slack.com/share/enQtMTE5MTg2Nzk3ODAxOTMtY2VkNDEyYWNkYThiZGQwYTZlNGVjNzliOTA1N2EyYTM5NzdiYjU1NmZiMjE2OWM5N2MyZGE5YzMzYWYyMTgyMw" class="external-link" target="_blank">
      #bioconnect-support
    </a>    
  </div>
</div>